/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { Form, Input, Table, Modal, Radio, Spin } from "antd";
// import { Link } from "react-router-dom";
import Api from "../../../services/ServiceApi";
class Supplier extends Component {
  editForm = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,
      menu: [
        { icon: "ma_list.svg", title: "MA List", link: "" },
        {
          icon: "ma_team_service.svg",
          title: "MA Team Service",
          link: "/ma_team_service",
        },
        { icon: "", title: "Material Stock", link: "/material_stock" },
        {
          icon: "notifications.svg",
          title: "Notifications",
          link: "/notifications",
        },
        { icon: "report.svg", title: "Report", link: "/report" },
        { icon: "", title: "Setting", link: "/setting" },
      ],
      data: [
        {
          key: "1",
          supplier_id: "123234234",
          supplier_code: "5001",
          supplier_name: "BNO",
          create_date: "07/01/2019 18.00",
          create_by: "chanakarn_r",
          status: 1,
        },
        {
          key: "2",
          supplier_id: "123234235",
          supplier_code: "5002",
          supplier_name: "Hello",
          create_date: "07/01/2019 18.00",
          create_by: "chanakarn_r",
          status: 1,
        },
      ],
      columns: [
        {
          title: "Supplier ID",
          render: (item) => (!item.supplier_id ? "-" : item.supplier_id),
          align: "center",
          key: "supplier_id",
          sorter: (a, b) => 
          (a.supplier_id === null || a.supplier_id  === undefined ? 0: a.supplier_id) -
          (b.supplier_id === null || b.supplier_id  === undefined ? 0: b.supplier_id),  
        },
        {
          title: "Supplier Code",
          render: (item) => (!item.supplier_code ? "-" : item.supplier_code),
          align: "center",
          sorter: (a, b) => 
          (a.supplier_id === null || a.supplier_id  === undefined ? "": a.supplier_id).localeCompare
          (b.supplier_id === null || b.supplier_id  === undefined ? "": b.supplier_id),  
        },
        {
          title: "Supplier Name",
          render: (item) => (!item.supplier_name ? "-" : item.supplier_name),
          align: "center",
          key: "supplier_name",
          sorter: (a, b) => 
          (a.supplier_name === null || a.supplier_name  === undefined ? "": a.supplier_name).localeCompare
          (b.supplier_name === null || b.supplier_name  === undefined ? "": b.supplier_name),  
        },
        {
          title: "Create date",
          render: (item) => (!item.create_date ? "-" : item.create_date),
          align: "center",
          key: "create_date",
          sorter: (a, b) => 
          (a.create_date === null || a.create_date  === undefined ? "": a.create_date).localeCompare
          (b.create_date === null || b.create_date  === undefined ? "": b.create_date),        
         },
        {
          title: "Create by",
          render: (item) => (!item.create_by ? "-" : item.create_by),
          // sorter: () => null,
          algin: "center",
          key: "create_by",
          sorter: (a, b) => 
          (a.create_by === null || a.create_by  === undefined ? "": a.create_by).localeCompare
          (b.create_by === null || b.create_by  === undefined ? "": b.create_by),  
        },
        {
          title: "Status",
          dataIndex: "status",
          align: "center",
          key: "status",
          sorter: () => null,
          render: (item) => (
            <div>
              {+item === 0 ? (
                <span></span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
        },
        {
          title: "Action",
          sorter: () => null,
          render: (item) => (
            <div>
              {/* <Link to="/edit_job"> */}
                {/* <img src={Api.absoluteUrl("/icon/view.svg")} width="35" /> */}
              {/* </Link> */}
              {/* <Link to="/edit_job"> */}
                <img src={Api.absoluteUrl("/icon/edit.svg")} style={{cursor: "pointer"}} onClick={() => this.onModal(true, "edit", item)} />
              {/* </Link> */}
              {/* <Link to="/edit_job"> */}
                <img src={Api.absoluteUrl("/icon/delete.svg")} style={{cursor: "pointer"}} onClick={() => this.onModal(true, "delete", item)}  />
              {/* </Link> */}
            </div>
          ),
        },
      ],
      visible: false,
      // value: 1,
      mode: "",
      visible_delete: false,
      modal_data: null,
      is_active : 1,
      loading_modal_delete: false,
    };
  }

  componentDidMount(){}

  handleSubmit(values) {
    console.log("Success:", values);
  }

  onChange = (e) => {
    this.setState({ is_active: e.target.value });
  };

  async onModal(visible, mode, data) {
    console.log(data);
    if(mode === "add"){
      this.setState({ 
        visible: visible,
        mode: mode,
        modal_data: null,
      });
    }else if (mode === "edit"){
      await this.setState({
        modal_data: data,
        mode: mode,
        visible: visible,
        is_active: data.status,
      })
      // await this.editForm.current.setFieldsValue({
      //     supplier_code: data.supplier_code
      // })
    }else if (mode === "delete"){
      this.setState({ 
        modal_data: data,
        mode: mode,
        visible_delete: visible,
      });
      // this.editForm.current.setFieldsValue({
      //     supplier_code: data.supplier_code
      // })
    } else {
      this.setState({ 
        visible_delete: visible,
        visible: visible,
        mode: "",
        modal_data: null,
      });
    }
  }

  renderSupplier() {
    const { visible, is_active, modal_data, mode } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode.toUpperCase()} Supplier
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
      >
        {mode === "edit"?
        <div className="d-flex align-items-center">
           <div className="mr-4">
             <span className="font-thai-r fs-18">Status</span>
           </div>
           <Radio.Group onChange={this.onChange} defaultValue={is_active}>
             <Radio value={1}>
               <span className="font-thai-r fs-18">Active</span>
             </Radio>
             <Radio value={2}>
               <span className="font-thai-r fs-18">Inactive</span>
             </Radio>
           </Radio.Group>
         </div>
        :null}

        <Form
          onFinish={(values) => this.handleSubmit(values)}
          layout="vertical"
          ref={this.editForm}
          initialValues={{
            supplier_code: modal_data != null ? modal_data.supplier_code : null,
            supplier_name: modal_data != null ? modal_data.supplier_name : null,
          }}
        >
          <div className="row">
            <div className="col">
              <Form.Item
                name="supplier_code"
                label="Supplier Code"
                rules={[{ required: true, message: "Supplier code is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="supplier_name"
                label="Supplier Name"
                rules={[{ required: true, message: "Supplier code is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Form.Item
                name="tel"
                label="Tel"
                rules={[{ required: true, message: "Tel no. is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                  // value={"dd"}
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="fax"
                label="Fax"
                // rules={[{ required: true, message: "Fax is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                  // value={"dd"}
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <Form.Item
                name="contact_person"
                label="Contact Person"
                rules={[{ required: true, message: "Contact person's name is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                  // value={"dd"}
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="tel"
                label="Contact Tel"
                rules={[{ required: true, message: "Contact person's telephone number is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                  // value={"dd"}
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <Form.Item
                name="email"
                label="Contact E-mail"
                rules={[{ required: true, message: "Contact's E-mail  is required" }]}
              >
                <Input
                  className="font-mont-r fs-12"
                  type="text"
                  size="large"
                  placeholder="Please Input"
                  // value={"dd"}
                />
              </Form.Item>
            </div>
          </div>

          <Form.Item
            name="supplier_address"
            label="Supplier Address"
            rules={[{ required: true, message: "Supplier address is required" }]}
          >
            <Input.TextArea
              rows="3"
              className="font-mont-r fs-12"
              type="text"
              size="large"
              placeholder="Please Input"
              // value="dd"
            />
          </Form.Item>
          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.onModal(false)}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success">Add</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  renderDelete() {
    const { loading_modal_delete, visible_delete } = this.state;
    // Add Material Form
    return (
      <Fragment>
        <Modal
          title={"Delete Employee"}
          centered={true}
          visible={visible_delete}
          footer={false}
          destroyOnClose={true}
          onCancel={this.ModalClosed}
        >
          <Spin spinning={loading_modal_delete}>

            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname === "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  Are you sure?
                </span>
              </div>
            </div>

            <div
              style={{
                fontFamily: "MontserratM",
                fontWeight: "bold",
                color: "#0500A3",
              }}
            >
              <div>
                <div className="row">
                  <div className="col text-center justify-content-between">
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.setState({ visible_delete: false })}
                      className="btn btn-secondary"
                    >
                      No
                    </button>
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.handleDelete()}
                      className="btn btn-danger"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* </Form> */}
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  handleDelete(){
  }

  render() {
    const { data, columns , visible} = this.state;

    return (
      <div>
        {this.renderDelete()}
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">Supplier</h3>

        <div className="d-flex justify-content-between my-3">
          <Input.Search
            placeholder="Search"
            onSearch={(value) => console.log(value)}
            style={{ width: 200 }}
          />

          <button
            className="btn btn-warning"
            onClick={() => this.onModal(true, "add", null)}
          >
            <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
            Add Supplier
          </button>
        </div>

        <Table columns={columns} dataSource={data} pagination={false} />

        {visible ? this.renderSupplier() : null}
      </div>
    );
  }
}
export default Supplier;
